<template>
    <div class="page_bom">
        <div class="bom">
            <div class="left">
                <div class="classTiy" v-for="(item,index) in bomClassTiyList" :key="index">
                    <div class="tiy-title" @click="handlJupe(item)">
                        {{item.title}}
                    </div>
                    <div class="classMess" v-for="(newItem,newIndex) in item.list">
                        <div class="mess-age">
                            {{newItem.text}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="line"></div>
            <div class="xiangJun_detal">
                <div class="incorName">
                    {{company.fullName}}
                </div>
                <div class="incorAdress">
                    公司地址：{{company.address}}
                </div>
                <div class="incorPhone">
                    全国客服热线：{{company.phone}}
                </div>
                <div class="incorLogo">
                    <!--          $global.Local + company.logo   -->
                    <img src="https://xiangjunkeji.cn/CM-API/upload/2021-05-06/2021-05-066252.jpg"/>
                </div>
            </div>
        </div>
        <div class="page_banQuan">
          <a href="https://beian.miit.gov.cn">
            版权所有：四川相君科技有限公司 备案号：{{company.recordNum}}
          </a>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                company: '',
                bomClassTiyList: [{
                    title: '首页',
                    path: '/'
                },
                    {
                        title: '印章管理',
                        path: 'sealListZhang'
                    },
                    {
                        title: '合同签署',
                        path: 'contractSin'

                    },
                    {
                        title: '签章验证',
                        // path: 'signInsp'
                        path: 'youKe'

                    },
                    {
                        title: '会员中心',
                        path: 'vipCenter'
                    },
                    {
                        title: '登录首页',
                        path: 'loginMenu'

                    }
                ]
            }
        },
        watch: {
            '$store.store.state.pidearData': function (newVal, oldVal) {
                //你需要执行的代码
                this.company = newVal
            }

        },
        created() {
            let _this = this;
            _this.company = JSON.parse(localStorage.getItem('pidearData')) || _this.$store.store.state.pidearData

        },
        methods: {
            handlJupe(item) {
                if (item.title == '签章验证') {
                    if (localStorage.getItem('login')) {
                        this.$router.push(item.path);
                    } else {
                        this.$router.push('youKe');
                    }
                } else {
                    this.$router.push(item.path);
                }


            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../static/less/xm.less';

    .page_bom {
        width: @a;
        height: 500px;
        background-color: #f2f2f2;

        .bom {
            width: @a;
            height: 400px;
            display: @flex;
            justify-content: center;
            padding: 20px;
            box-sizing: border-box;

            .left {
                width: 858px;
                height: @a;
                @row();

                .classTiy {
                    width: 100px;
                    height: @a;
                    margin-top: 40px;

                    .tiy-title {
                        cursor: pointer;
                        width: @a;
                        height: 20px;
                        font-family: MicrosoftYaHei-Bold;
                        font-size: 18px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 0px;
                        color: #333333;
                        line-height: 20px;
                        text-align: center;
                    }

                    .classMess {
                        width: 100px;
                        height: auto;
                        margin-top: 25px;

                        .mess-age {
                            width: @a;
                            height: 20px;
                            font-family: MicrosoftYaHei;
                            font-size: 16px;
                            font-weight: normal;
                            font-stretch: normal;
                            line-height: 36px;
                            letter-spacing: 0px;
                            color: #777777;
                            line-height: 20px;
                            text-align: center;
                        }
                    }
                }
            }

            .line {
                width: 1px;
                height: @a;
                background-color: #777777;
                margin: 0 30px;
            }

            .xiangJun_detal {
                width: 500px;
                height: @a;
                margin-top: 40px;

                .incorName {
                    width: auto;
                    height: 20px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 18px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #333333;
                }

                .incorAdress {
                    width: 410px;
                    height: 20px;
                    margin-top: 25px;
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #777777;
                    white-space: nowrap;
                }

                .incorPhone {
                    width: 403px;
                    height: 20px;
                    margin-top: 25px;
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #777777;
                }

                .incorLogo {
                    margin-top: 32px;
                    width: 160px;
                    height: 160px;
                    background-color: #ffffff;

                    img {
                        width: @a;
                        height: @a;
                        object-fit: cover;
                    }
                }
            }
        }

        .page_banQuan {
            width: @a;
            height: 100px;
            @row();
            font-family: MicrosoftYaHei;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 36px;
            letter-spacing: 0px;
            color: #f5f5f5;
            background-color: #808080;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/nav/nav-bom.vue